import React from "react";
import BodyDash from "./BodyDash";
import CarouselDash from "./CarouselDash";
import Footer from "./Footer";
import Navbar from "./Navbar";
import SearchNav from "./SearchNav.jsx";

const Dashboard = () => {
  return (
    <>
      <div style={{ backgroundColor: "#050A30" }}>
        <Navbar title={true} />
        <SearchNav />
        <CarouselDash />
        <BodyDash />
        <Footer />
      </div>
    </>
  );
};

export default Dashboard;
